import { Check } from "lucide-react";

export function SignupSuccess() {
  return (
    <div className="flex flex-col items-center justify-center gap-6 text-center max-w-sm h-full">
      <div className="flex items-center justify-center size-28 rounded-full bg-tag-lime">
        <Check className="size-12 text-tag-lime-foreground" strokeWidth={3} />
      </div>
      <span className="text-xl font-semibold max-w-[80%]">
        Account created successfully
      </span>
      <span className="text-md text-muted-foreground">
        Redirecting to dashboard
      </span>
    </div>
  );
}
